import type { UnreadNotification } from '@/types/notification'
import { defineStore } from 'pinia'

export const useDialogStore = defineStore('dialog', {
  state: () => ({
    show: false as boolean,
    message: '' as string,
    unread: [] as UnreadNotification[],
  }),
  actions: {
    open(message: string, unread: UnreadNotification[] = []) {
      this.message = message
      this.unread = unread
      this.show = true
    },
    close() {
      this.show = false
      this.message = ''
      this.unread = []
    },
  },
})
